import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-screen bg-gray flex items-center justify-center px-6 py-12 overflow-hidden">
      {/* Background SVG */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <svg
          viewBox="0 0 1440 800"
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#5A8DEE" /> {/* blue */}
              <stop offset="100%" stopColor="#A29BFE" /> {/* purple */}
            </linearGradient>
            <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#00B894" stopOpacity="0.4" /> {/* green */}
              <stop offset="100%" stopColor="#A29BFE" stopOpacity="0.3" /> {/* purple */}
            </linearGradient>
          </defs>

          <path
            fill="url(#gradient1)"
            d="M0,160 C480,240 960,80 1440,160 L1440,0 L0,0 Z"
            opacity="0.8"
          />
          <path
            fill="url(#gradient2)"
            d="M0,400 C400,300 1040,500 1440,400 L1440,0 L0,0 Z"
            opacity="0.6"
          />
          <path
            fill="url(#gradient1)"
            d="M0,700 C500,800 1000,600 1440,720 L1440,0 L0,0 Z"
            opacity="0.4"
          />
        </svg>
      </div>

      {/* Hero Content */}
      <div className="z-10 max-w-3xl text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-gray leading-tight">
          Welcome to <span className="text-blue">LangBridge</span>
        </h1>
        <p className="mt-6 text-lg md:text-xl text-charcoal">
          Your personal language learning assistant — translate, practice, and improve your grammar with AI.
        </p>

        <div className="mt-8 space-x-4">
          <Link
            to="/register"
            className="inline-block px-6 py-3 bg-blue text-white rounded-lg shadow-md hover:bg-purple transition"
          >
            Get Started
          </Link>
          <Link
            to="/login"
            className="inline-block px-6 py-3 border border-blue text-blue rounded-lg hover:bg-blue hover:text-white transition"
          >
            Login
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
